import { render, staticRenderFns } from "./bot.vue?vue&type=template&id=50b27ceb&"
import script from "./bot.vue?vue&type=script&lang=js&"
export * from "./bot.vue?vue&type=script&lang=js&"
import style0 from "./bot.vue?vue&type=style&index=0&id=50b27ceb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports